"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionLink = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("./");
require("./ActionLink.scss");
const ActionLink = _ref => {
  let {
    iconName,
    children,
    href,
    onClick,
    className,
    theme = _.ACTION_LINK_THEME.default,
    iconSize = _.ACTION_LINK_ICON_SIZE.default,
    iconPosition = _.ACTION_LINK_ICON_POSITION.left,
    target = _.ACTION_LINK_TARGET.self,
    dataAttributes
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-ActionLink', {
    [`cds-ActionLink--${(0, _upperCase.upperCaseFirst)(theme)}`]: theme,
    'cds-Link': !!href,
    'cds-ButtonLink': !href
  }, className);
  const icon = iconName && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: iconName,
    size: iconSize,
    className: (0, _classnames.default)('cds-ActionLink-Icon', `cds-ActionLink-Icon--${(0, _upperCase.upperCaseFirst)(iconPosition)}`)
  });
  const dataAttributesItems = (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes);
  const content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, iconPosition === _.ACTION_LINK_ICON_POSITION.left && icon, children && /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-ActionLink-Content"
  }, children), iconPosition === _.ACTION_LINK_ICON_POSITION.right && icon);
  if (href) {
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
      href: href,
      className: rootClassName,
      target: target
    }, dataAttributesItems), content);
  }
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    type: "button",
    onClick: onClick,
    className: rootClassName
  }, dataAttributesItems), content);
};
exports.ActionLink = ActionLink;
//# sourceMappingURL=ActionLink.js.map